import React, { createContext, useContext, useState, useEffect } from 'react';
import { loaderInstance } from './LoaderSingleton';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  // Attach once to the singleton
  useEffect(() => {
    loaderInstance.attach(setLoading);
  }, []);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);